// extracted by mini-css-extract-plugin
module.exports = {"body":"WhatsappCommBody_body__2tTQs"};